<template>
    <div id="news-edu-mobile">
        <div class="main-content">
            <div class="wrapper">
                <h3 class="titles">
                    かんたん号外くん<br />
                    利用ルール
                </h3>
                <p><b>かんたん号外くんは学習用教材です。ルールを守って、新聞学習を行いましょう。</b></p>
                <p>「お友達や他人を傷つける内容や、嫌がる内容の記事・写真を載せてはいけません」</p>
                <p>「たくさんの人が読むかもしれません。お友達や他人に知られては困ることも載せないよう気をつけて」 </p>
                <p>「ほかの人が書いた文章やイラスト、ほかの人が撮影した写真を無断でコピペして使用してはいけません」</p>
                <p>「写真に写っている人の許可はとりましたか？」</p>
                <p>「そのほか、先生の注意をよく聞いてね」</p>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "RegulationMobile",
		data() {
		    return {
		        URL: 'https://www.sankei.com/nie/create-newspaper/'
				}
		}
	}
</script>

<style scoped lang="scss">
</style>